import React, { useCallback } from 'react';

import { JSONTree } from 'react-json-tree';
import { get } from 'lodash';
import { Container, Typography, Paper, Box, Alert } from '@mui/material';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

export default function LMSResults({ data }: { data: any }) {
  const { error, dataSent, submissionDate, lms } = data;
  // Helper to generate CSV string from the data

  // Download handler
  const handleDownloadCSV = () => {
    const csv = generateCSV();
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'lms_data.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const categories = Object.keys(dataSent || {});
  // Helper to generate CSV string from the data
  const generateCSV = useCallback(() => {
    let csv = '';
    categories.forEach(category => {
      const obj = dataSent[category];
      if (obj) {
        csv += `${category}\n`;
        csv += Object.keys(obj).join(',') + '\n';
        csv +=
          Object.values(obj)
            .map(v => `"${String(v).replace(/"/g, '""')}"`)
            .join(',') + '\n\n';
      }
    });
    return csv;
  }, [categories, dataSent]);

  return (
    <Paper sx={{ padding: 2 }}>
      <Container maxWidth="xl">
        <Typography variant="subtitle1" color="text.primary" sx={{ fontWeight: 500, mr: 1 }}>
          Sent to:{' '}
          {lms
            .replace(/_/g, ' ')
            .toLowerCase()
            .replace(/\b(\w)/g, (char: string) => char.toUpperCase())}
        </Typography>
        <Box mb={2} display="flex" alignItems="center">
          <CalendarTodayIcon fontSize="small" sx={{ color: 'text.secondary', mr: 1 }} />
          <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 500, mr: 1 }}>
            Submission date:
          </Typography>
          <Typography variant="body2" color="text.primary">
            {submissionDate ? new Date(submissionDate).toLocaleString() : '-'}
          </Typography>
        </Box>
        {error ? (
          <Box mb={2}>
            <Alert severity="error">
              <b>Error ocurred:</b> <p>{error}</p>
            </Alert>
          </Box>
        ) : (
          <Box mb={2}>
            <Alert severity="success">
              <b>Submitted via API </b>
            </Alert>
          </Box>
        )}

        <Box display="flex" justifyContent="flex-end" mb={2}>
          <Button variant="contained" size="small" startIcon={<DownloadIcon />} onClick={handleDownloadCSV}>
            Download CSV
          </Button>
        </Box>
        {
          <>
            <p>Data Structure:</p>
            <JSONTree
              data={dataSent}
              theme={{
                scheme: 'monokai',
                author: 'wimer hazenberg (http://www.monokai.nl)',
                base00: '#272822',
                base01: '#383830',
                base02: '#49483e',
                base03: '#75715e',
                base04: '#a59f85',
                base05: '#f8f8f2',
                base06: '#f5f4f1',
                base07: '#f9f8f5',
                base08: '#f92672',
                base09: '#fd971f',
                base0A: '#f4bf75',
                base0B: '#a6e22e',
                base0C: '#a1efe4',
                base0D: '#66d9ef',
                base0E: '#ae81ff',
                base0F: '#cc6633',
              }}
            />
          </>
        }
      </Container>
    </Paper>
  );
}
